export default __webpack_public_path__ + "static/contact-bg-up-e1eb64e9496570e20a3414d4a4798dcf.png";